import { render, staticRenderFns } from "./express.vue?vue&type=template&id=59cd5aa8&scoped=true"
import script from "./express.vue?vue&type=script&lang=js"
export * from "./express.vue?vue&type=script&lang=js"
import style0 from "./express.vue?vue&type=style&index=0&id=59cd5aa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cd5aa8",
  null
  
)

export default component.exports